import dimensionEnum from "@/model/dimensionEnum";
import mesureEnum from "@/model/mesureEnum";
import TableTools from "./tableTools";
import i18n from "@/plugins/vue-i18n";
import { groupKeyEnum } from "@/model/columnsEnums";
import { calculatedColumnsEnum } from "@/model/columnsEnums";
import _ from "lodash";

export const operationsHelper = {
    dimensionsTable1 : [dimensionEnum.SITE, dimensionEnum.SITE_CURRENCY],

    getOmniplayFilters(filters) {
      // Ajout du filtre pour exclure les events annulés
      let eventFilters = [...filters];
      eventFilters.push({
        dimension: dimensionEnum.OMNIPLAYEVENT_ISCANCELLED,
        operator: "equals",
        values: ["0"],
      });

      return eventFilters;
    },

    getQueriesTable1(filters, purchaseHistoryFilters, eventFilters = null, timeDimension = null){
        const purchaseHistoryTimeDimension = timeDimension
          ? { ...timeDimension, dimension: dimensionEnum.PURCHASEHISTORY_DATETIME }
          : null;

        let queries = [];
        queries.push({
          query: {
            measures: [
              mesureEnum.PURCHASEHISTORY_AMOUNT,
              mesureEnum.PURCHASEHISTORY_TOKEN,
              mesureEnum.PURCHASEHISTORY_BONUSTOKEN,
              mesureEnum.PURCHASEHISTORY_COUNTSOLDCARDS,
            ],
            dimensions: this.dimensionsTable1,
            timeDimensions: purchaseHistoryTimeDimension ? [purchaseHistoryTimeDimension] : [],
            filters: purchaseHistoryFilters,
          },
        });

        queries.push({
          query: {
            measures: [mesureEnum.ADJUSTMENTHISTORY_TOKENCREDITED],
            dimensions: this.dimensionsTable1,
            timeDimensions: timeDimension ? [timeDimension] : [],
            filters: filters,
          },
        });

        queries.push({
          query: {
            measures: [mesureEnum.STAFFGAMEHISTORY_TOKENCREDITED],
            dimensions: this.dimensionsTable1,
            timeDimensions: timeDimension ? [timeDimension] : [],
            filters: filters,
          },
        });

        queries.push({
          query: {
            measures: [mesureEnum.SNACKHISTORY_AMOUNT_CB_TTC],
            dimensions: this.dimensionsTable1,
            timeDimensions: timeDimension ? [timeDimension] : [],
            filters: filters,
          },
        });

        if(eventFilters != null){
          queries.push({
            query: {
              measures: [mesureEnum.OMNIPLAYEVENT_TOTALTTC],
              dimensions: this.dimensionsTable1,
              timeDimensions: timeDimension ? [timeDimension] : [],
              filters: eventFilters,
            },
          });
          queries.push({
            query: {
              measures: [
                  mesureEnum.OMNIPLAYEVENT_TOTAL_BONUS_TOKEN
              ],
              dimensions: this.dimensionsTable1,
              timeDimensions: timeDimension ? [timeDimension] : [],
              filters: eventFilters
            }
          });
        }

        return queries;
    },

    getQueriesTable2(filters, eventFilters = null, timeDimension = null){
        const gameHistoryTimeDimension = timeDimension
          ? { ...timeDimension, dimension: dimensionEnum.GAMEHISTORY_DATETIME }
          : null;

        let queries = [];

        let gamesFilters = [...filters];
        gamesFilters.push(TableTools.Helper.getFilterGameNotFree());

        queries.push({
          groupKey: groupKeyEnum.GROUP_GAMES,
          query: {
            measures: [
              mesureEnum.GAMEHISTORY_TOKEN,
              mesureEnum.GAMEHISTORY_TOKEN_PRICE,
              mesureEnum.GAMEHISTORY_TOKEN_PRICE_HT,
              mesureEnum.GAMEHISTORY_BONUSTOKEN,
            ],
            dimensions: [
              dimensionEnum.SITE,
              dimensionEnum.GAMEHISTORY_TAXESPERCENT,
              dimensionEnum.SITE_CURRENCY
            ],
            timeDimensions: gameHistoryTimeDimension ? [gameHistoryTimeDimension] : [],
            filters: gamesFilters,
          },
        });

        queries.push({
          groupKey: groupKeyEnum.GROUP_SNACK,
          query: {
            measures: [
              mesureEnum.SNACKHISTORY_TOTALTOKEN_WITHOUTCB,
              mesureEnum.SNACKHISTORY_TOKEN_PRICE,
              mesureEnum.SNACKHISTORY_TOKEN_PRICE_HT,
              mesureEnum.SNACKHISTORY_AMOUNT_CB_TTC,
            ],
            dimensions: [
              dimensionEnum.SNACKHISTORY_TAXESPERCENT,
              dimensionEnum.SNACKPRODUCT_TYPE,
              dimensionEnum.SNACKHISTORY_ISPAYMENTCB,
              dimensionEnum.SITE_CURRENCY,
              dimensionEnum.SITE,
            ],
            timeDimensions: timeDimension ? [timeDimension] : [],
            filters: filters,
          },
        });

        if(eventFilters != null){
          queries.push({
            groupKey: groupKeyEnum.GROUP_EVENTS,
            query: {
              measures: [
                mesureEnum.OMNIPLAYEVENT_TOTALHT,
                mesureEnum.OMNIPLAYEVENT_TOTALTTC
              ],
              dimensions: [
                dimensionEnum.SITE,
                dimensionEnum.OMNIPLAYEVENT_TRANSACTIONS
              ],
              timeDimensions: timeDimension ? [timeDimension] : [],
              filters: eventFilters
            }
          });
        }

        return queries;
    },

    /** Concaténation des données, renommage des clés pour les données qui doivent apparaître dans la même colonne,
     * ajout de la colonne de libellés et des colonnes calculées  */
    mergeAndCompleteResultsTable2(resultSets) {
      var concatenatedResults = [];
      const vatKey = "VatRate";
      const priceTTCKey = "PriceTTC";
      const priceHTKey = "PriceHT";

      resultSets.forEach((set) => {
        //On groupe par type et type de payement (pour les types de conso)
        const groupByType = _.groupBy(
          set.resultSet.loadResponse.results[0].data,
          (value) => {
            // On verifie si on est bien avec des produits Snack/Merch (pas de jeux)
            // et si c'est le cas, on créé la clé de groupement : type-de-produit + type-payement
            return dimensionEnum.SNACKPRODUCT_TYPE in value
              ? [
                value[dimensionEnum.SNACKPRODUCT_TYPE],
                value[dimensionEnum.SNACKHISTORY_ISPAYMENTCB],
              ]
              : undefined;
          }
        );
        // Foramtion du groupByType pour les events
        // On fait un regroupement par TVA de transactions
        if (
          set.groupKey === groupKeyEnum.GROUP_EVENTS &&
          groupByType["undefined"]
        ) {
          // as we do have multiple sites we need to group by dimensionEnum.Site
          const groupedBySite = _.groupBy(groupByType["undefined"], (value) => {
            return value[dimensionEnum.SITE];
          });
          groupByType["undefined"] = []
          Object.entries(groupedBySite).forEach(([siteId, resultBySite]) => {
            // récupérations des transcation
            const transactions = resultBySite.map(item => {
              const transactionsJson = JSON.parse(item[dimensionEnum.OMNIPLAYEVENT_TRANSACTIONS]);
              return transactionsJson.Values;
            });
            // Mise a plat de toutes les transaction dans un meme tableau
            const transactionsFlat = _.flatMap(transactions, (transactions) => transactions);
            // groupement des transaction par taux de TVA
            const groupedData = _.groupBy(transactionsFlat, vatKey);
            // regroupement de toutes les transactions pour chaque taux de TVA
            // on fait la somme des TTC, la somme des HT, la somme des tokens bonus
            const groupedDataTotal = _.mapValues(groupedData, (transactions) => {
              return _.reduce(transactions, (acc, transaction) => {
                acc[priceTTCKey] += transaction[priceTTCKey];
                acc[priceHTKey] += transaction[priceHTKey];
                acc[vatKey] = transaction[vatKey];
                return acc;
              }, {
                [priceTTCKey]: 0,
                [priceHTKey]: 0,
                [vatKey]: 0,
              });
            });
            //Mise en forme des données pour l'affichage
            Object.entries(groupedDataTotal).forEach(([key, value]) => {
              value[dimensionEnum.SITE] = siteId
              groupByType["undefined"].push(value)
            });
          })
        }
        Object.keys(groupByType).forEach((key) => {
          var results = groupByType[key],
            groupKey = set.groupKey;
          if (key !== "undefined") {
            groupKey += key;
          }

          results.forEach((result) => {
            result[calculatedColumnsEnum.SALE_CATEGORY] = i18n.t(groupKey);
            TableTools.Helper.renameKey(
              result,
              mesureEnum.GAMEHISTORY_TOKEN,
              calculatedColumnsEnum.TOKEN_QUANTITY
            );
            TableTools.Helper.renameKey(
              result,
              mesureEnum.SNACKHISTORY_TOTALTOKEN_WITHOUTCB,
              calculatedColumnsEnum.TOKEN_QUANTITY
            );
            TableTools.Helper.renameKey(
              result,
              mesureEnum.SNACKHISTORY_TOKEN_PRICE,
              calculatedColumnsEnum.REVENUE_TTC
            );

            TableTools.Helper.renameKey(
              result,
              mesureEnum.GAMEHISTORY_TOKEN_PRICE,
              calculatedColumnsEnum.REVENUE_TTC
            );

            TableTools.Helper.renameKey(
              result,
              mesureEnum.SNACKHISTORY_TOKEN_PRICE_HT,
              calculatedColumnsEnum.REVENUE_HT
            );

            TableTools.Helper.renameKey(
              result,
              mesureEnum.GAMEHISTORY_TOKEN_PRICE_HT,
              calculatedColumnsEnum.REVENUE_HT
            );

            TableTools.Helper.renameKey(
              result,
              priceTTCKey,
              calculatedColumnsEnum.REVENUE_TTC
            );

            TableTools.Helper.renameKey(
              result,
              priceHTKey,
              calculatedColumnsEnum.REVENUE_HT
            );

            TableTools.Helper.renameKey(
              result,
              vatKey,
              calculatedColumnsEnum.TAXES_PERCENTAGE
            );

            TableTools.Helper.renameKey(
              result,
              dimensionEnum.SNACKHISTORY_TAXESPERCENT,
              calculatedColumnsEnum.TAXES_PERCENTAGE
            );
            TableTools.Helper.renameKey(
              result,
              dimensionEnum.GAMEHISTORY_TAXESPERCENT,
              calculatedColumnsEnum.TAXES_PERCENTAGE
            );
            TableTools.Helper.renameKey(
              result,
              mesureEnum.GAMEHISTORY_BONUSTOKEN,
              calculatedColumnsEnum.BONUS_TOKEN_QUANTITY
            );

            concatenatedResults.push(result);
          });
        });
      });

      // as we do have multiple sites we need to group by dimensionEnum.Site
      concatenatedResults = _.groupBy(concatenatedResults, (value) => {
        return value[dimensionEnum.SITE];
      });

      Object.entries(concatenatedResults).forEach(([,resultBySite]) => {

        // first we do need the total revenu of this site
        let totalRevenue = _.sumBy(resultBySite, (value) => {
          return value[calculatedColumnsEnum.REVENUE_TTC] || 0;
        });

        resultBySite.forEach((result) => {
          // TVA
          const amountTtc = result[calculatedColumnsEnum.REVENUE_TTC] || 0;
          const amountHt = result[calculatedColumnsEnum.REVENUE_HT] || 0;
          result[calculatedColumnsEnum.REVENUE_TVA] = amountTtc - amountHt

          const totalUnitConsumed =
            result[calculatedColumnsEnum.TOKEN_QUANTITY] +
            result[calculatedColumnsEnum.BONUS_TOKEN_QUANTITY];
          const percentUnitBonusConsumed =
            (result[calculatedColumnsEnum.BONUS_TOKEN_QUANTITY] * 100) /
            totalUnitConsumed;
          if (result[calculatedColumnsEnum.BONUS_TOKEN_QUANTITY] != undefined) {
            result[calculatedColumnsEnum.PERCENT_BONUS_TOKEN] = percentUnitBonusConsumed;
          }

          const revenue = result[calculatedColumnsEnum.REVENUE_TTC] || 0;
          result[calculatedColumnsEnum.PERCENT_PER_ACTIVITY] =
            (revenue * 100) / totalRevenue || 0;
        });
      });

      return concatenatedResults;
    },
}
